<script setup>
import { Line } from 'vue-chartjs'
import Duration from '@common/Duration'

const { DateTime } = require('luxon')
import { onMounted, reactive } from 'vue'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
)

const data = reactive([])

const additionalDurations = [
  {
    id: _.uniqueId('SST_'),
    label: 'Totaal per maand',
    key: 'MONTH_TOTALS',
  },
]

const options = {
  onClick: (e) => {
    const chart = e.chart

    // Substitute the appropriate scale IDs
    const dataX = chart.scales.x.getValueForPixel(e.x)
    const date = chart.scales.x.getLabelForValue(dataX)
    const dataY = chart.scales.y.getValueForPixel(e.y)
    const formattedDate = DateTime.fromFormat(date, 'dd/mm/yyyy').toFormat(
      'yyyy-mm-dd'
    )
    window.open(`/admin/retours/?filters[sst_date]=${formattedDate}`)
  },
}

const chartData = reactive({
  labels: [],
  datasets: [
    {
      label: 'Totaal (in Euro)',
      backgroundColor: 'rgb(194,149,209)',
      borderColor: 'rgb(221,99,255)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgb(194,149,209)',
      hoverBorderColor: 'rgb(221,99,255)',
      data: [],
    },
  ],
  responsive: true,
  maintainAspectRatio: false
})

const handle = (point, event) => {
  console.log(point, event)
}

const fetchDataForDuration = (duration) => {
  axios
    .get(
      route('api.graphs.fetch.sst', {
        duration: duration,
      })
    )
    .then((response) => {
      chartData.labels = response.data.map((item) => {
        return DateTime.fromISO(item.sst_date).toLocaleString(
          DateTime.DATE_SHORT
        )
      })
      chartData.datasets[0].data = response.data.map((item) => {
        return {
          x: DateTime.fromISO(item.sst_date).toLocaleString(
            DateTime.DATE_SHORT
          ),
          y: item.price_end,
        }
      })
    })
    .catch((error) => {
      console.error(error)
    })
}
</script>

<template>
  <div class="space-y-4">
    <div class="text-xl">SST totalen</div>
    <Duration
      @update-selected="fetchDataForDuration"
      :additionalDurations="additionalDurations"
    />
    <div class="hidden lg:block">
      <Line
        :chart-data="chartData"
        :height="100"
        class="mt-4"
        :chart-options="options"
      ></Line>
    </div>
    <div class="lg:hidden">
      <Line
        :chart-data="chartData"
        :height="400"
        class="mt-4"
        :chart-options="options"
      ></Line>
    </div>
  </div>
</template>


